/* eslint-disable */
/**
 * @see https://nodejs.org/api/url.html#url_url_strings_and_url_objects url的组成
 * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript when the code comes from
 */
function getURLSearchParams(searchOrQuery) {
  const ret = {}
  return searchOrQuery
    ? (/^[?#]/i.test(searchOrQuery) ? searchOrQuery.slice(1) : searchOrQuery)
        .split('&')
        .reduce((params, param) => {
          const [key, value] = param.split('=')
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, ' '))
            : ''
          return params
        }, ret)
    : ret
}

function queryAllSearchParams() {
  if (!window.URLSearchParams) {
    return getURLSearchParams(location.search)
  }
  const urlParams = new URLSearchParams(location.search)
  const allParams = {}
  Array.from(urlParams.entries()).forEach(param => {
    const [key, value] = param
    if (key !== 'key') {
      allParams[key] = decodeURIComponent(value)
    }
  })
  return allParams
}
export default queryAllSearchParams
